<template>
    <component :is="tag">
        <slot
            :step="step"
            :brief="brief"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :brief-fields="briefFields"
            :isLoading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :errors="errors"
            :errorMessage="errorMessage"
        />
    </component>
</template>

<script>
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import {NAME_PERSONAL_INFO} from '../../../constants/activation-brief-steps';

    export default {
        name:   'ActivationBriefPersonalInfoProvider',
        mixins: [
            BaseActivationBriefStepMixin,
        ],
        computed: {
            step(){
                return this.steps[NAME_PERSONAL_INFO];
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadActivationBrief(),
                        this.loadActivationBriefFields(),
                    ]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
    };
</script>
